export default function TextInput({ id, ...props }) {
    return <input id={id} {...props} className="border rounded p-2 w-full" />;
  }
  